module.exports = __webpack_public_path__ + "static/img/sms_010512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sms_010512.jpg
// module id = HW17
// module chunks = 1